import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=7fc81062&scoped=true&"
import script from "./GoBackButton.vue?vue&type=script&lang=ts&"
export * from "./GoBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=7fc81062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc81062",
  null
  
)

export default component.exports